import { createFeatureSelector, createSelector } from '@ngrx/store';

import { AddressState } from '@store/state/address.state';

import { MonitoringItem } from '../../app/portal/pages/monitoring-page/monitoring.types';

export const selectAddressFeature = createFeatureSelector<AddressState>('address');

export const selectAddressMap = createSelector(selectAddressFeature, (state) => state.addressMap);

export const selectAddressLoading = createSelector(selectAddressFeature, (state) => state.loading);

export const selectAddressError = createSelector(selectAddressFeature, (state) => state.error);

export const selectUsedCoordinateKeys = createSelector(
  (state: any) => state.monitoring.entities,
  (entities: Record<number, MonitoringItem>) =>
    new Set(
      Object.values(entities)
        .filter((item): item is MonitoringItem => !!item)
        .map((item) => item.coordinateKey)
        .filter((key): key is string => !!key),
    ),
);

export const selectAddressForKey = (key: string) =>
  createSelector(selectAddressMap, (map) => map[key] || null);
